import { FC, useEffect, useState } from 'react'
import { TablesWidget } from '../../../../../../_metronic/partials/widgets'
import { KTIcon } from '../../../../../../_metronic/helpers'
import { TableSearchComponent } from '../../../../../../_metronic/partials/widgets/search-input/TableSearchComponent'
import { DateFormat } from '../../../../../../_metronic/helpers/components/DateFormat'
import { Button, Popover } from 'react-bootstrap'
import { useTheme } from '../../../../../../_metronic/partials/layout/app-theme/ThemeContext'
import Table from '../../common/Table'
import TableHeader from '../../common/TableHeader'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../../redux/store'
import { deleteOfferApi, getOfferListApi } from '../../../../../redux/slices/OfferSlice'
import { toast } from 'react-toastify'

const OfferTable: FC = () => {
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchKey, setSearchKey] = useState('')
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
    const [selectedRow, setSelectedRow] = useState([])
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const { theme } = useTheme()

    const offerSelectorData = useSelector(
        (state: RootState) => state.offer.OfferList?.data?.data || []
    )
    const offerSelectorTotal = useSelector(
        (state: RootState) => state.offer.OfferList?.data?.total || 0
    )

    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            setDebouncedSearchQuery(searchKey)
        }, 1000)

        return () => clearTimeout(debounceTimeout)
    }, [searchKey])

    const fetchofferListGetApi = () => {
        setLoading(true)

        dispatch(
            getOfferListApi({
                pageNumber: currentPage,
                pageSize: rowsPerPage,
                filterkey: debouncedSearchQuery,
            })
        )
            .then((value: any) => {
                setLoading(false)
            })
            .catch((error: any) => {
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchofferListGetApi()
    }, [currentPage, rowsPerPage, debouncedSearchQuery])

    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            setDebouncedSearchQuery(searchKey)
        }, 1000)

        return () => clearTimeout(debounceTimeout)
    }, [searchKey])

    // Actions
    const handleEdit = (id: any) => {
        navigate(`edit/${id}`)
    }

    const handleView = async (id: any) => {
        try {
            const response: any = await dispatch(
                getOfferListApi({
                    pageNumber: currentPage,
                    pageSize: rowsPerPage,
                    filterkey: "",
                })
            );

            const selectedCatalogue = response.payload?.data?.data?.find((catalogue: any) => catalogue.id === id);
            const offer_drive_link = selectedCatalogue?.offer_drive_link || selectedCatalogue?.offer_drive_link;
        
            if (offer_drive_link) {
                window.open(offer_drive_link, "_blank");
            } else {
                toast.error("Dive link not found");
            }

        } catch (error) {
            toast.error("Error fetching offer data");
          }
    }

    const handleDelete = (id: any) => {
        dispatch(deleteOfferApi(id)).then((response: any) => {
            if (response.payload.success) {
                toast.success(response.payload.reason)
                fetchofferListGetApi()
            } else {
                toast.error(response.payload.reason || 'Something went wrong')
            }
        })
        
    }


    const handleSearchChange = (searchQuery: string) => {
        setSearchKey(searchQuery)
    }

    const handlePageChange = (page: number) => {
        setCurrentPage(page)
    }

    const handlePerRowsChange = (newPerPage: number, page: number) => {
        setCurrentPage(page)
        setRowsPerPage(newPerPage)
    }

    const columnData = [
        { name: 'Name', selector: (row: any) => row?.name, sortable: true },
        {
            name: 'Status',
            cell: (row: any) => (row?.is_active === 1 ? 'Active' : 'Inactive'),
            sortable: true,
          },   
        {
            name: 'Created At',
            selector: (row: any) => new Date(row?.created_at).toLocaleDateString(),
            sortable: true,
          },
        {
            name: 'Actions',
            cell: (row: any) => (
                <div>
                     <div
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        onClick={() => handleView(row?.id)}
                     >
                        <KTIcon iconName='eye' className='fs-3' /> 
                    </div>
                    <div
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        onClick={() => handleEdit(row?.id)}
                    >
                        <KTIcon iconName='pencil' className='fs-3' />
                    </div>
                    <div
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        onClick={() => handleDelete(row?.id)}
                    >
                        <KTIcon iconName='trash' className='fs-3' />
                    </div>
                </div>
            ),
            sortable: false,
            style: { textAlign: 'left' },
        },
    ]

    return (
        <div className='card'>
            <TableHeader
                search={searchKey}
                addButtonText={'Add offer'}
                handleSearchChange={handleSearchChange}
                handleAddButton={() => navigate('add')}
                showFilter={true}
                // additionalButtons={[
                //   {icon: 'bi-pencil', tooltip: 'Edit', onClick: () => console.log('Edit clicked')},
                // ]}
                filterContent={
                    <div>
                        <p>Custom filter form</p>
                        <div className='d-flex justify-content-end'>
                            <Button variant='secondary' className='me-2'>
                                Close
                            </Button>
                            <Button variant={`${theme}`}>Apply Filters</Button>
                        </div>
                    </div>
                }
            />

            <div className='card-body p-0 shadow-sm'>
                <Table
                    data={offerSelectorData}
                    columns={columnData}
                    isLoading={loading}
                    handlePerRowsChange={handlePerRowsChange}
                    handlePageChange={handlePageChange}
                    totalRows={offerSelectorTotal}
                    showPagination={true}
                    onRowClicked={(row) => {
                    }}
                    selectableRows
                    onSelectedRowsChange={(selected) => {
                        setSelectedRow(selected.selectedRows)
                    }}
                />
            </div>
        </div>
    )
}

export default OfferTable
